var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('map-of-united-states'),_vm._v(" "),_c('fragrances-by-state-leaderboards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }